import { InternalCommentStatusEnum } from '../../../../types/internal-comment';
import { WorksheetInternalCommentOverview } from '../../../../types/worksheet';

type CommentsStats = { active: number; resolved: number };

/**
 * Reduces the number of active and resolved comments on a worksheet to a stats object.
 *
 */
export function commentsReducer(acc: CommentsStats, ic: WorksheetInternalCommentOverview): CommentsStats {
    if (ic.status === InternalCommentStatusEnum.ACTIVE) {
        acc.active += 1;
    } else {
        acc.resolved += 1;
    }
    return acc;
}
